var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recent-comment" }, [
    _c("div", { staticClass: "d-flex align-items-top" }, [
      _c(
        "div",
        { staticClass: "pr-2" },
        [
          _c("user-icon", {
            attrs: { userid: _vm.commentData["user.user_name"] }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {}, [
        _c("div", {
          staticClass: "username-text d-block d-sm-inline-block",
          domProps: {
            innerHTML: _vm._s(
              _vm.parseUserName(_vm.commentData["user.user_name"])
            )
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "comment-timestamp d-block d-sm-inline-block" },
          [
            _vm._v(
              _vm._s(
                _vm.getCommentDisplayTime(_vm.commentData["sys_created_on"])
              )
            )
          ]
        ),
        _vm._v(" "),
        _vm.isAdmin
          ? _c(
              "div",
              {
                staticClass: "reply-admin-role-text d-block d-sm-inline-block"
              },
              [
                _vm._v("ADMIN\n        "),
                _vm.commentData.comments &&
                _vm.commentData.u_email_only &&
                _vm.commentData.u_email_only === "true"
                  ? _c("span", [_vm._v(" - RESPONDED VIA EMAIL")])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.commentData.comments &&
    (!_vm.commentData.u_email_only || _vm.commentData.u_email_only === "false")
      ? _c(
          "div",
          { staticClass: "comment-text" },
          [
            _c("froalaView", {
              model: {
                value: _vm.commentData.comments,
                callback: function($$v) {
                  _vm.$set(_vm.commentData, "comments", $$v)
                },
                expression: "commentData.comments"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7001e1bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7001e1bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeArticleComment.vue
// module id = null
// module chunks = 